//

// ******************************************************************
// * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. *
// ******************************************************************

import { DiscoveryApi } from '../types/discovery';
import { FetchApi } from '../types/fetch';
import crossFetch from 'cross-fetch';
import { pluginId } from '../pluginId';
import * as parser from 'uri-template';
import { FluxHelmRelease } from '../models/FluxHelmRelease.model';
import { FluxHelmReleasesInner } from '../models/FluxHelmReleasesInner.model';
import { HelmReleaseSearchResultInner } from '../models/HelmReleaseSearchResultInner.model';
import { HelmReleasesInner } from '../models/HelmReleasesInner.model';

/**
 * Wraps the Response type to convey a type on the json call.
 *
 * @public
 */
export type TypedResponse<T> = Omit<Response, 'json'> & {
  json: () => Promise<T>;
};

/**
 * Options you can pass into a request for additional information.
 *
 * @public
 */
export interface RequestOptions {
  token?: string;
}
/**
 * @public
 */
export type GetFluxHelmrelease = {
  path: {
    name: string;
    environment: string;
    version: string;
  };
  query: {
    namespace?: string;
  };
};
/**
 * @public
 */
export type GetFluxHelmreleases = {
  path: {
    namespace: string;
    name: string;
  };
};
/**
 * @public
 */
export type GetHelmreleases = {
  path: {
    namespace: string;
    release: string;
  };
};
/**
 * @public
 */
export type GetHelmreleasesHistory = {
  path: {
    namespace: string;
    release: string;
  };
  query: {
    env: string;
    limit?: number;
  };
};
/**
 * @public
 */
export type SearchHelmreleases = {
  query: {
    q: string;
    limit?: string;
  };
};

/**
 * @public
 */
export class DefaultApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  /**
   * get helmrelease
   * @param name - the release name
   * @param environment - the environment of the release
   * @param version - the version of the release
   * @param namespace - the namespace of the release (optional filter)
   */
  public async getFluxHelmrelease(
    // @ts-ignore
    request: GetFluxHelmrelease,
    options?: RequestOptions,
  ): Promise<TypedResponse<FluxHelmRelease>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/v2/{name}/{environment}/{version}{?namespace}`;

    const uri = parser.parse(uriTemplate).expand({
      name: request.path.name,
      environment: request.path.environment,
      version: request.path.version,
      ...request.query,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * latest helmrelease
   * @param namespace -
   * @param name - the release name
   */
  public async getFluxHelmreleases(
    // @ts-ignore
    request: GetFluxHelmreleases,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<FluxHelmReleasesInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/v2/{namespace}/{name}`;

    const uri = parser.parse(uriTemplate).expand({
      namespace: request.path.namespace,
      name: request.path.name,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * latest helmrelease
   * @param namespace -
   * @param release - the release name
   */
  public async getHelmreleases(
    // @ts-ignore
    request: GetHelmreleases,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<HelmReleasesInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/{namespace}/{release}`;

    const uri = parser.parse(uriTemplate).expand({
      namespace: request.path.namespace,
      release: request.path.release,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * helmrelease history
   * @param env - the environment
   * @param namespace -
   * @param release - the release name
   * @param limit - the numer of records to fetch
   */
  public async getHelmreleasesHistory(
    // @ts-ignore
    request: GetHelmreleasesHistory,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<HelmReleasesInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/{namespace}/{release}/history{?env,limit}`;

    const uri = parser.parse(uriTemplate).expand({
      namespace: request.path.namespace,
      release: request.path.release,
      ...request.query,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * search helmreleases
   * @param q -
   * @param limit - the number of records to fetch
   */
  public async searchHelmreleases(
    // @ts-ignore
    request: SearchHelmreleases,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<HelmReleaseSearchResultInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/search{?q,limit}`;

    const uri = parser.parse(uriTemplate).expand({
      ...request.query,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }
}
